// // src/services/returnsService.js
// import { 
//   collection, 
//   doc, 
//   addDoc, 
//   updateDoc, 
//   deleteDoc, 
//   query, 
//   where, 
//   orderBy, 
//   limit, 
//   startAfter, 
//   getDocs, 
//   getDoc,
//   Timestamp,
//   writeBatch
// } from 'firebase/firestore';
// import { db } from './firebase';
// import { getAuth } from 'firebase/auth';

// // Generate return request ID
// const generateReturnId = () => {
//   const timestamp = Date.now().toString(36);
//   const randomStr = Math.random().toString(36).substring(2, 8);
//   return `RET-${timestamp}-${randomStr}`.toUpperCase();
// };

// // Create a new return request
// export const createReturnRequest = async (returnData) => {
//   try {
//     const auth = getAuth();
//     const currentUser = auth.currentUser;
    
//     if (!currentUser) {
//       throw new Error('User not authenticated');
//     }

//     const returnRequest = {
//       ...returnData,
//       returnId: generateReturnId(),
//       vendorId: currentUser.uid,
//       status: 'pending',
//       createdAt: Timestamp.now(),
//       updatedAt: Timestamp.now(),
//       totalRefundAmount: returnData.items.reduce((sum, item) => 
//         sum + (item.returnQuantity * item.unitPrice), 0
//       )
//     };

//     const docRef = await addDoc(collection(db, 'returns'), returnRequest);
    
//     // Update product inventory if return is approved automatically
//     if (returnData.autoApprove) {
//       await updateInventoryForReturn(returnData.items, 'approved');
//     }

//     return {
//       id: docRef.id,
//       ...returnRequest
//     };
//   } catch (error) {
//     console.error('Error creating return request:', error);
//     throw new Error(`Failed to create return request: ${error.message}`);
//   }
// };

// // Get all return requests for the vendor
// export const getReturnRequests = async (options = {}) => {
//   try {
//     const auth = getAuth();
//     const currentUser = auth.currentUser;
    
//     if (!currentUser) {
//       throw new Error('User not authenticated');
//     }

//     const {
//       pageSize = 25,
//       lastDoc = null,
//       status = null,
//       searchTerm = '',
//       sortBy = 'createdAt',
//       sortOrder = 'desc'
//     } = options;

//     // Start with basic vendorId filter only to avoid index requirements
//     let q = query(
//       collection(db, 'returns'),
//       where('vendorId', '==', currentUser.uid),
//       limit(pageSize)
//     );

//     // Add status filter if specified
//     if (status && status !== 'all') {
//       q = query(q, where('status', '==', status));
//     }

//     // Add pagination if provided
//     if (lastDoc) {
//       q = query(q, startAfter(lastDoc));
//     }

//     console.log('Executing returns query...');
//     const snapshot = await getDocs(q);
//     console.log('Returns query completed, docs found:', snapshot.docs.length);
    
//     let returns = snapshot.docs.map(doc => {
//       const data = doc.data();
//       return {
//         id: doc.id,
//         ...data,
//         createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || Date.now()),
//         updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : new Date(data.updatedAt || Date.now())
//       };
//     });

//     console.log('Returns mapped, count:', returns.length);

//     // Apply client-side sorting since we can't use orderBy with where clauses without an index
//     if (sortBy === 'createdAt') {
//       returns = returns.sort((a, b) => {
//         const dateA = new Date(a.createdAt);
//         const dateB = new Date(b.createdAt);
//         return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
//       });
//     } else if (sortBy === 'totalRefundAmount') {
//       returns = returns.sort((a, b) => {
//         const amountA = a.totalRefundAmount || 0;
//         const amountB = b.totalRefundAmount || 0;
//         return sortOrder === 'desc' ? amountB - amountA : amountA - amountB;
//       });
//     }

//     // Apply search filter on client side if needed
//     if (searchTerm && searchTerm.trim()) {
//       const searchLower = searchTerm.toLowerCase();
//       returns = returns.filter(returnReq => 
//         returnReq.returnId?.toLowerCase().includes(searchLower) ||
//         returnReq.customerName?.toLowerCase().includes(searchLower) ||
//         returnReq.invoiceNumber?.toLowerCase().includes(searchLower) ||
//         returnReq.reason?.toLowerCase().includes(searchLower)
//       );
//     }

//     const lastVisible = snapshot.docs[snapshot.docs.length - 1];
//     const hasMore = snapshot.docs.length === pageSize;

//     console.log('Final returns processed:', returns.length);

//     return {
//       returns,
//       lastDoc: lastVisible,
//       hasMore,
//       total: returns.length
//     };
//   } catch (error) {
//     console.error('Error getting return requests:', error);
    
//     // If the query fails, return empty results instead of throwing
//     console.log('Returning empty results due to error');
//     return {
//       returns: [],
//       lastDoc: null,
//       hasMore: false,
//       total: 0
//     };
//   }
// };

// // Get a specific return request by ID
// export const getReturnById = async (returnId) => {
//   try {
//     const docRef = doc(db, 'returns', returnId);
//     const docSnap = await getDoc(docRef);
    
//     if (!docSnap.exists()) {
//       return null;
//     }

//     const data = docSnap.data();
//     return {
//       id: docSnap.id,
//       ...data,
//       createdAt: data.createdAt?.toDate() || new Date(),
//       updatedAt: data.updatedAt?.toDate() || new Date()
//     };
//   } catch (error) {
//     console.error('Error getting return by ID:', error);
//     throw new Error(`Failed to get return details: ${error.message}`);
//   }
// };

// // Update return request status
// export const updateReturnStatus = async (returnId, newStatus, notes = '') => {
//   try {
//     const auth = getAuth();
//     const currentUser = auth.currentUser;
    
//     if (!currentUser) {
//       throw new Error('User not authenticated');
//     }

//     const returnRef = doc(db, 'returns', returnId);
//     const returnDoc = await getDoc(returnRef);
    
//     if (!returnDoc.exists()) {
//       throw new Error('Return request not found');
//     }

//     const returnData = returnDoc.data();
    
//     // Verify ownership
//     if (returnData.vendorId !== currentUser.uid) {
//       throw new Error('Unauthorized to update this return request');
//     }

//     const updateData = {
//       status: newStatus,
//       updatedAt: Timestamp.now(),
//       [`${newStatus}At`]: Timestamp.now()
//     };

//     if (notes) {
//       updateData.statusNotes = notes;
//     }

//     // If approving return, update inventory
//     if (newStatus === 'approved' && returnData.status !== 'approved') {
//       await updateInventoryForReturn(returnData.items, 'approved');
//     }

//     // If rejecting after approval, revert inventory
//     if (newStatus === 'rejected' && returnData.status === 'approved') {
//       await updateInventoryForReturn(returnData.items, 'rejected');
//     }

//     await updateDoc(returnRef, updateData);

//     return {
//       id: returnId,
//       ...returnData,
//       ...updateData
//     };
//   } catch (error) {
//     console.error('Error updating return status:', error);
//     throw new Error(`Failed to update return status: ${error.message}`);
//   }
// };

// // Update inventory based on return status
// const updateInventoryForReturn = async (returnItems, status) => {
//   try {
//     const batch = writeBatch(db);

//     for (const item of returnItems) {
//       if (item.productId) {
//         const productRef = doc(db, 'products', item.productId);
//         const productDoc = await getDoc(productRef);
        
//         if (productDoc.exists()) {
//           const productData = productDoc.data();
//           let newStock = productData.stock || 0;
//           let newReturned = productData.totalReturned || 0;

//           if (status === 'approved') {
//             // Add returned items back to stock
//             newStock += item.returnQuantity;
//             newReturned += item.returnQuantity;
//           } else if (status === 'rejected') {
//             // Remove returned items from stock (if they were previously added)
//             newStock = Math.max(0, newStock - item.returnQuantity);
//             newReturned = Math.max(0, newReturned - item.returnQuantity);
//           }

//           batch.update(productRef, {
//             stock: newStock,
//             totalReturned: newReturned,
//             updatedAt: Timestamp.now()
//           });
//         }
//       }
//     }

//     await batch.commit();
//   } catch (error) {
//     console.error('Error updating inventory for return:', error);
//     throw new Error(`Failed to update inventory: ${error.message}`);
//   }
// };

// // Delete return request
// export const deleteReturnRequest = async (returnId) => {
//   try {
//     const auth = getAuth();
//     const currentUser = auth.currentUser;
    
//     if (!currentUser) {
//       throw new Error('User not authenticated');
//     }

//     const returnRef = doc(db, 'returns', returnId);
//     const returnDoc = await getDoc(returnRef);
    
//     if (!returnDoc.exists()) {
//       throw new Error('Return request not found');
//     }

//     const returnData = returnDoc.data();
    
//     // Verify ownership
//     if (returnData.vendorId !== currentUser.uid) {
//       throw new Error('Unauthorized to delete this return request');
//     }

//     // If return was approved, revert inventory changes
//     if (returnData.status === 'approved') {
//       await updateInventoryForReturn(returnData.items, 'rejected');
//     }

//     await deleteDoc(returnRef);
//     return true;
//   } catch (error) {
//     console.error('Error deleting return request:', error);
//     throw new Error(`Failed to delete return request: ${error.message}`);
//   }
// };

// // Get return statistics for dashboard
// export const getReturnStatistics = async (dateRange = {}) => {
//   try {
//     const auth = getAuth();
//     const currentUser = auth.currentUser;
    
//     if (!currentUser) {
//       throw new Error('User not authenticated');
//     }

//     // Use simple query without orderBy to avoid index requirements
//     let q = query(
//       collection(db, 'returns'),
//       where('vendorId', '==', currentUser.uid)
//     );

//     console.log('Fetching return statistics...');
//     const snapshot = await getDocs(q);
//     console.log('Return stats query completed, docs found:', snapshot.docs.length);
    
//     let returns = snapshot.docs.map(doc => {
//       const data = doc.data();
//       return {
//         ...data,
//         createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || Date.now())
//       };
//     });

//     // Apply date range filter on client side if provided
//     if (dateRange.start || dateRange.end) {
//       returns = returns.filter(returnReq => {
//         const returnDate = returnReq.createdAt;
//         if (dateRange.start && returnDate < dateRange.start.toDate()) return false;
//         if (dateRange.end && returnDate > dateRange.end.toDate()) return false;
//         return true;
//       });
//     }

//     const stats = {
//       totalReturns: returns.length,
//       pendingReturns: returns.filter(r => r.status === 'pending').length,
//       approvedReturns: returns.filter(r => r.status === 'approved').length,
//       rejectedReturns: returns.filter(r => r.status === 'rejected').length,
//       totalRefundAmount: returns
//         .filter(r => r.status === 'approved')
//         .reduce((sum, r) => sum + (r.totalRefundAmount || 0), 0),
//       returnsByDate: {},
//       returnsByReason: {}
//     };

//     // Group returns by date
//     returns.forEach(returnReq => {
//       const date = returnReq.createdAt?.toISOString?.()?.split('T')[0] || 
//                    new Date().toISOString().split('T')[0];
      
//       if (!stats.returnsByDate[date]) {
//         stats.returnsByDate[date] = 0;
//       }
//       stats.returnsByDate[date]++;

//       // Group by reason
//       const reason = returnReq.reason || 'Other';
//       if (!stats.returnsByReason[reason]) {
//         stats.returnsByReason[reason] = 0;
//       }
//       stats.returnsByReason[reason]++;
//     });

//     console.log('Return statistics calculated:', stats);
//     return stats;
//   } catch (error) {
//     console.error('Error getting return statistics:', error);
    
//     // Return default stats on error
//     return {
//       totalReturns: 0,
//       pendingReturns: 0,
//       approvedReturns: 0,
//       rejectedReturns: 0,
//       totalRefundAmount: 0,
//       returnsByDate: {},
//       returnsByReason: {}
//     };
//   }
// };

// // Get invoices for returns (to populate return request form)
// export const getInvoicesForReturns = async (options = {}) => {
//   try {
//     const auth = getAuth();
//     const currentUser = auth.currentUser;
    
//     console.log('=== INVOICE LOADING DEBUG ===');
//     console.log('Current user:', currentUser?.uid);
    
//     if (!currentUser) {
//       throw new Error('User not authenticated');
//     }

//     const { pageSize = 50, searchTerm = '' } = options;
//     console.log('Loading invoices with options:', { pageSize, searchTerm });

//     // First, try to get ALL invoices for this vendor (without any additional filters)
//     let q = query(
//       collection(db, 'invoices'),
//       where('vendorId', '==', currentUser.uid)
//     );

//     console.log('Executing invoice query...');
//     const snapshot = await getDocs(q);
//     console.log('Invoice query completed. Raw documents found:', snapshot.docs.length);
    
//     // Log each invoice found
//     snapshot.docs.forEach((doc, index) => {
//       const data = doc.data();
//       console.log(`Invoice ${index + 1}:`, {
//         id: doc.id,
//         invoiceNumber: data.invoiceNumber || 'No invoice number',
//         status: data.status || 'No status',
//         customerName: data.customerName || 'No customer name',
//         itemsCount: data.items ? data.items.length : 'No items array',
//         createdAt: data.createdAt ? 'Has createdAt' : 'No createdAt',
//         totalAmount: data.totalAmount || 'No total amount'
//       });
//     });

//     let invoices = snapshot.docs.map(doc => {
//       const data = doc.data();
//       return {
//         id: doc.id,
//         ...data,
//         createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || Date.now())
//       };
//     });

//     console.log('Raw invoices mapped:', invoices.length);

//     // More lenient filtering - let's see what we're filtering out
//     const beforeFilter = invoices.length;
//     invoices = invoices.filter(invoice => {
//       const hasItems = invoice.items && Array.isArray(invoice.items) && invoice.items.length > 0;
//       const hasStatus = invoice.status; // Any status is fine for now
      
//       if (!hasItems) {
//         console.log('Filtered out invoice (no items):', invoice.invoiceNumber, invoice.items);
//       }
//       if (!hasStatus) {
//         console.log('Filtered out invoice (no status):', invoice.invoiceNumber, invoice.status);
//       }
      
//       return hasItems; // Only require items, not status
//     });

//     console.log(`Filtering: ${beforeFilter} -> ${invoices.length} invoices`);

//     // Sort by creation date (newest first)
//     invoices = invoices.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

//     // Apply search filter
//     if (searchTerm && searchTerm.trim()) {
//       const beforeSearch = invoices.length;
//       const searchLower = searchTerm.toLowerCase();
//       invoices = invoices.filter(invoice => 
//         invoice.invoiceNumber?.toLowerCase().includes(searchLower) ||
//         invoice.customerName?.toLowerCase().includes(searchLower) ||
//         invoice.customerEmail?.toLowerCase().includes(searchLower)
//       );
//       console.log(`Search filter: ${beforeSearch} -> ${invoices.length} invoices`);
//     }

//     console.log('Final invoices to return:', invoices.length);
//     console.log('=== END INVOICE DEBUG ===');

//     return invoices;
//   } catch (error) {
//     console.error('Error getting invoices for returns:', error);
//     console.error('Error details:', error.message);
    
//     // Return empty array instead of throwing
//     console.log('Returning empty array due to error');
//     return [];
//   }
// };



import { 
  collection, 
  doc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  orderBy, 
  limit, 
  startAfter, 
  getDocs, 
  getDoc,
  Timestamp,
  writeBatch
} from 'firebase/firestore';
import { db } from './firebase';
import { getAuth } from 'firebase/auth';

// Generate return request ID
const generateReturnId = () => {
  const timestamp = Date.now().toString(36);
  const randomStr = Math.random().toString(36).substring(2, 8);
  return `RET-${timestamp}-${randomStr}`.toUpperCase();
};

// Create a new return request
export const createReturnRequest = async (returnData) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    const returnRequest = {
      ...returnData,
      returnId: generateReturnId(),
      vendorId: currentUser.uid,
      status: 'pending',
      createdAt: Timestamp.now(),
      updatedAt: Timestamp.now(),
      totalRefundAmount: returnData.items.reduce((sum, item) => 
        sum + (item.returnQuantity * item.unitPrice), 0
      )
    };

    const docRef = await addDoc(collection(db, 'returns'), returnRequest);
    
    // Update product inventory if return is approved automatically
    if (returnData.autoApprove) {
      await updateInventoryForReturn(returnData.items, 'approved');
    }

    return {
      id: docRef.id,
      ...returnRequest
    };
  } catch (error) {
    console.error('Error creating return request:', error);
    throw new Error(`Failed to create return request: ${error.message}`);
  }
};

// Get all return requests for the vendor
export const getReturnRequests = async (options = {}) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    const {
      pageSize = 25,
      lastDoc = null,
      status = null,
      searchTerm = '',
      sortBy = 'createdAt',
      sortOrder = 'desc'
    } = options;

    let q = query(
      collection(db, 'returns'),
      where('vendorId', '==', currentUser.uid),
      limit(pageSize)
    );

    if (status && status !== 'all') {
      q = query(q, where('status', '==', status));
    }

    if (lastDoc) {
      q = query(q, startAfter(lastDoc));
    }

    console.log('Executing returns query...');
    const snapshot = await getDocs(q);
    console.log('Returns query completed, docs found:', snapshot.docs.length);
    
    let returns = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || Date.now()),
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : new Date(data.updatedAt || Date.now())
      };
    });

    console.log('Returns mapped, count:', returns.length);

    if (sortBy === 'createdAt') {
      returns = returns.sort((a, b) => {
        const dateA = new Date(a.createdAt);
        const dateB = new Date(b.createdAt);
        return sortOrder === 'desc' ? dateB - dateA : dateA - dateB;
      });
    } else if (sortBy === 'totalRefundAmount') {
      returns = returns.sort((a, b) => {
        const amountA = a.totalRefundAmount || 0;
        const amountB = b.totalRefundAmount || 0;
        return sortOrder === 'desc' ? amountB - amountA : amountA - amountB;
      });
    }

    if (searchTerm && searchTerm.trim()) {
      const searchLower = searchTerm.toLowerCase();
      returns = returns.filter(returnReq => 
        returnReq.returnId?.toLowerCase().includes(searchLower) ||
        returnReq.customerName?.toLowerCase().includes(searchLower) ||
        returnReq.invoiceNumber?.toLowerCase().includes(searchLower) ||
        returnReq.reason?.toLowerCase().includes(searchLower)
      );
    }

    const lastVisible = snapshot.docs[snapshot.docs.length - 1];
    const hasMore = snapshot.docs.length === pageSize;

    console.log('Final returns processed:', returns.length);

    return {
      returns,
      lastDoc: lastVisible,
      hasMore,
      total: returns.length
    };
  } catch (error) {
    console.error('Error getting return requests:', error);
    return {
      returns: [],
      lastDoc: null,
      hasMore: false,
      total: 0
    };
  }
};

// Get a specific return request by ID
export const getReturnById = async (returnId) => {
  try {
    const docRef = doc(db, 'returns', returnId);
    const docSnap = await getDoc(docRef);
    
    if (!docSnap.exists()) {
      return null;
    }

    const data = docSnap.data();
    return {
      id: docSnap.id,
      ...data,
      createdAt: data.createdAt?.toDate() || new Date(),
      updatedAt: data.updatedAt?.toDate() || new Date()
    };
  } catch (error) {
    console.error('Error getting return by ID:', error);
    throw new Error(`Failed to get return details: ${error.message}`);
  }
};

// Update return request status
export const updateReturnStatus = async (returnId, newStatus, notes = '') => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    const returnRef = doc(db, 'returns', returnId);
    const returnDoc = await getDoc(returnRef);
    
    if (!returnDoc.exists()) {
      throw new Error('Return request not found');
    }

    const returnData = returnDoc.data();
    
    if (returnData.vendorId !== currentUser.uid) {
      throw new Error('Unauthorized to update this return request');
    }

    const updateData = {
      status: newStatus,
      updatedAt: Timestamp.now(),
      [`${newStatus}At`]: Timestamp.now()
    };

    if (notes) {
      updateData.statusNotes = notes;
    }

    if (newStatus === 'approved' && returnData.status !== 'approved') {
      await updateInventoryForReturn(returnData.items, 'approved');
    }

    if (newStatus === 'rejected' && returnData.status === 'approved') {
      await updateInventoryForReturn(returnData.items, 'rejected');
    }

    await updateDoc(returnRef, updateData);

    return {
      id: returnId,
      ...returnData,
      ...updateData
    };
  } catch (error) {
    console.error('Error updating return status:', error);
    throw new Error(`Failed to update return status: ${error.message}`);
  }
};

// Update inventory based on return status
const updateInventoryForReturn = async (returnItems, status) => {
  try {
    const batch = writeBatch(db);

    for (const item of returnItems) {
      if (item.productId) {
        const productRef = doc(db, 'products', item.productId);
        const productDoc = await getDoc(productRef);
        
        if (productDoc.exists()) {
          const productData = productDoc.data();
          let newStock = productData.stock || 0;
          let newReturned = productData.totalReturned || 0;

          if (status === 'approved') {
            newStock += item.returnQuantity;
            newReturned += item.returnQuantity;
          } else if (status === 'rejected') {
            newStock = Math.max(0, newStock - item.returnQuantity);
            newReturned = Math.max(0, newReturned - item.returnQuantity);
          }

          batch.update(productRef, {
            stock: newStock,
            totalReturned: newReturned,
            updatedAt: Timestamp.now()
          });
        }
      }
    }

    await batch.commit();
  } catch (error) {
    console.error('Error updating inventory for return:', error);
    throw new Error(`Failed to update inventory: ${error.message}`);
  }
};

// Delete return request
export const deleteReturnRequest = async (returnId) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    const returnRef = doc(db, 'returns', returnId);
    const returnDoc = await getDoc(returnRef);
    
    if (!returnDoc.exists()) {
      throw new Error('Return request not found');
    }

    const returnData = returnDoc.data();
    
    if (returnData.vendorId !== currentUser.uid) {
      throw new Error('Unauthorized to delete this return request');
    }

    if (returnData.status === 'approved') {
      await updateInventoryForReturn(returnData.items, 'rejected');
    }

    await deleteDoc(returnRef);
    return true;
  } catch (error) {
    console.error('Error deleting return request:', error);
    throw new Error(`Failed to delete return request: ${error.message}`);
  }
};

// Get return statistics for dashboard
export const getReturnStatistics = async (dateRange = {}) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    let q = query(
      collection(db, 'returns'),
      where('vendorId', '==', currentUser.uid)
    );

    console.log('Fetching return statistics...');
    const snapshot = await getDocs(q);
    console.log('Return stats query completed, docs found:', snapshot.docs.length);
    
    let returns = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || Date.now())
      };
    });

    if (dateRange.start || dateRange.end) {
      returns = returns.filter(returnReq => {
        const returnDate = returnReq.createdAt;
        if (dateRange.start && returnDate < dateRange.start.toDate()) return false;
        if (dateRange.end && returnDate > dateRange.end.toDate()) return false;
        return true;
      });
    }

    const stats = {
      totalReturns: returns.length,
      totalRefundAmount: returns.reduce((sum, r) => sum + (r.totalRefundAmount || 0), 0)
    };

    console.log('Return statistics calculated:', stats);
    return stats;
  } catch (error) {
    console.error('Error getting return statistics:', error);
    return {
      totalReturns: 0,
      totalRefundAmount: 0
    };
  }
};

// Get invoices for returns
export const getInvoicesForReturns = async (options = {}) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    console.log('=== INVOICE LOADING DEBUG ===');
    console.log('Current user:', currentUser?.uid);
    
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    const { pageSize = 50, searchTerm = '' } = options;
    console.log('Loading invoices with options:', { pageSize, searchTerm });

    let q = query(
      collection(db, 'invoices'),
      where('vendorId', '==', currentUser.uid)
    );

    console.log('Executing invoice query...');
    const snapshot = await getDocs(q);
    console.log('Invoice query completed. Raw documents found:', snapshot.docs.length);
    
    snapshot.docs.forEach((doc, index) => {
      const data = doc.data();
      console.log(`Invoice ${index + 1}:`, {
        id: doc.id,
        invoiceNumber: data.invoiceNumber || 'No invoice number',
        status: data.status || 'No status',
        customerName: data.customerName || 'No customer name',
        itemsCount: data.items ? data.items.length : 'No items array',
        createdAt: data.createdAt ? 'Has createdAt' : 'No createdAt',
        totalAmount: data.totalAmount || 'No total amount'
      });
    });

    let invoices = snapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt || Date.now())
      };
    });

    console.log('Raw invoices mapped:', invoices.length);

    const beforeFilter = invoices.length;
    invoices = invoices.filter(invoice => {
      const hasItems = invoice.items && Array.isArray(invoice.items) && invoice.items.length > 0;
      if (!hasItems) {
        console.log('Filtered out invoice (no items):', invoice.invoiceNumber, invoice.items);
      }
      return hasItems;
    });

    console.log(`Filtering: ${beforeFilter} -> ${invoices.length} invoices`);

    invoices = invoices.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    if (searchTerm && searchTerm.trim()) {
      const beforeSearch = invoices.length;
      const searchLower = searchTerm.toLowerCase();
      invoices = invoices.filter(invoice => 
        invoice.invoiceNumber?.toLowerCase().includes(searchLower) ||
        invoice.customerName?.toLowerCase().includes(searchLower) ||
        invoice.customerEmail?.toLowerCase().includes(searchLower)
      );
      console.log(`Search filter: ${beforeSearch} -> ${invoices.length} invoices`);
    }

    console.log('Final invoices to return:', invoices.length);
    console.log('=== END INVOICE DEBUG ===');

    return invoices;
  } catch (error) {
    console.error('Error getting invoices for returns:', error);
    console.error('Error details:', error.message);
    return [];
  }
};

// Update invoice items
export const updateInvoice = async (invoiceId, updatedItems) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;
    
    if (!currentUser) {
      throw new Error('User not authenticated');
    }

    const invoiceRef = doc(db, 'invoices', invoiceId);
    const invoiceDoc = await getDoc(invoiceRef);
    
    if (!invoiceDoc.exists()) {
      throw new Error('Invoice not found');
    }

    const invoiceData = invoiceDoc.data();
    
    if (invoiceData.vendorId !== currentUser.uid) {
      throw new Error('Unauthorized to update this invoice');
    }

    const totalAmount = updatedItems.reduce((sum, item) => 
      sum + (item.quantity * (item.rate || item.price || 0)), 0);

    await updateDoc(invoiceRef, {
      items: updatedItems,
      totalAmount,
      updatedAt: Timestamp.now()
    });

    return {
      id: invoiceId,
      ...invoiceData,
      items: updatedItems,
      totalAmount,
      updatedAt: new Date()
    };
  } catch (error) {
    console.error('Error updating invoice:', error);
    throw new Error(`Failed to update invoice: ${error.message}`);
  }
};